import { type RootState } from '@verantos-dev/core-annotation-tool';

export const selectSelectedTab = (state: RootState) => state.adminProject?.selectedTab;
export const selectDefaultAllocationModeEdit = (state: RootState) =>
  state.adminProject?.defaultAllocationModeEdit;
export const selectAnnotators = (state: RootState) => state.adminProject?.annotators;
export const selectSupervisors = (state: RootState) => state.adminProject?.supervisors;
export const selectProjectsListPage = (state: RootState) =>
  state.adminProject?.projectsListPage ?? 0;
export const selectProjectsListPageSize = (state: RootState) =>
  state.adminProject?.projectsListPageSize ?? 25;
